<!-- Loading Indicator -->
  @if (loading) {
<app-cmdb-sync-skeleton></app-cmdb-sync-skeleton>
}

        <!-- Success Message -->
        @if (successMessage) {
<div class="alert alert-success">
          <mat-icon>check_circle</mat-icon>
          {{ successMessage }}
        </div>
}

        <!-- Error Message -->
        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

        @if (!loading) {
<mat-tab-group [(selectedIndex)]="selectedTabIndex">

          <!-- Tab 1: Sync History -->
          <mat-tab label="Sync History">
            <div style="padding-top: 20px;">

              <!-- Sync Status Card -->
              @if (status) {
<div class="card" style="margin-bottom: 20px;">
                <div class="card-body">
                  <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
                    <!-- Trigger CMDB Sync (no Orion) -->
                    @if (!status.isSyncRunning) {
<button 
                     
                      type="button"
                      class="btn btn-primary no-arrow"
                      (click)="triggerSync()"
                      [disabled]="triggering"
                      title="Sync CMDB data only. Orion enrichment is NOT included. Use the Orion Sync button for that.">
                      @if (!triggering) {
<span>CMDB Sync</span>
}
                      @if (triggering) {
<span>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Triggering...
                      </span>
}
                    </button>
}
                    @if (status.isSyncRunning) {
<button 
                     
                      type="button"
                      class="btn btn-secondary no-arrow"
                      disabled>
                      <span>CMDB Sync</span>
                    </button>
}

                    <!-- Re-run Orion Enrichment -->
                    <button
                      type="button"
                      class="btn btn-outline-secondary no-arrow"
                      (click)="runOrionEnrichment()"
                      [disabled]="orionEnrichRunning || status.isSyncRunning"
                      title="Re-fetch Orion manifests for all apps. Does NOT re-sync CMDB data.">
                      @if (!orionEnrichRunning) {
<span>
                        <mat-icon style="font-size:16px;height:16px;width:16px;vertical-align:middle;">sync</mat-icon>
                        Orion Sync
                      </span>
}
                      @if (orionEnrichRunning) {
<span>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Enriching...
                      </span>
}
                    </button>
                  </div>
                </div>
              </div>
}

              <!-- Sync History Grid -->
              @if (historyLoading) {
<app-cmdb-sync-history-skeleton></app-cmdb-sync-history-skeleton>
}

              @if (!historyLoading) {
<div class="card">
                <div class="card-body">
                  <h3>Sync History</h3>
                  
                  @if (history.length === 0) {
<div style="text-align: center; padding: 20px; color: #666;">
                    <mat-icon style="font-size: 48px; height: 48px; width: 48px;">history</mat-icon>
                    <p>No sync history available</p>
                  </div>
}

                  @if (history.length > 0) {
<table mat-table [dataSource]="history" class="mat-elevation-z2" style="width: 100%;">
                    <ng-container matColumnDef="startedAt">
                      <th mat-header-cell *matHeaderCellDef>Started At</th>
                      <td mat-cell *matCellDef="let record">{{ formatDate(record.startedAt) }}</td>
                    </ng-container>
                    <ng-container matColumnDef="completedAt">
                      <th mat-header-cell *matHeaderCellDef>Completed At</th>
                      <td mat-cell *matCellDef="let record">{{ formatDate(record.completedAt) }}</td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                      <th mat-header-cell *matHeaderCellDef>Duration</th>
                      <td mat-cell *matCellDef="let record">
                        @if (!record.completedAt) {

                          <div style="display:flex;align-items:center;gap:8px;">
                            <app-spinner [isLoading]="true" diameter="22" loadingText=""></app-spinner>
                            <span class="muted">In progress...</span>
                          </div>
                        
} @else {

                          {{ formatDuration(record) }}
                        
}
                        
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="records">
                      <th mat-header-cell *matHeaderCellDef>Records</th>
                      <td mat-cell *matCellDef="let record">
                        <span class="record-stats">
                          @if (record.recordsInserted > 0) {
<span class="stat-item" title="Inserted">
                            <mat-icon class="stat-icon">add_circle</mat-icon>{{ record.recordsInserted }}
                          </span>
}
                          @if (record.recordsUpdated > 0) {
<span class="stat-item" title="Updated">
                            <mat-icon class="stat-icon">update</mat-icon>{{ record.recordsUpdated }}
                          </span>
}
                          @if (record.recordsSkipped > 0) {
<span class="stat-item" title="Skipped">
                            <mat-icon class="stat-icon">skip_next</mat-icon>{{ record.recordsSkipped }}
                          </span>
}
                          @if (record.recordsDeleted > 0) {
<span class="stat-item" title="Deleted">
                            <mat-icon class="stat-icon">delete</mat-icon>{{ record.recordsDeleted }}
                          </span>
}
                          @if (record.recordsErrored > 0) {
<span class="stat-item" title="Errors">
                            <mat-icon class="stat-icon error">error</mat-icon>{{ record.recordsErrored }}
                          </span>
}
                        </span>
                        <!-- Error message (moved from Details column) -->
                        @if (record.errorMessage) {
<div class="error-message" [title]="record.errorMessage" style="margin-top:6px; font-size:0.95em;">
                          <mat-icon class="error-icon">error_outline</mat-icon>
                          {{ record.errorMessage.length > 50 ? record.errorMessage.substring(0, 50) + '...' : record.errorMessage }}
                        </div>
}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="triggeredBy">
                      <th mat-header-cell *matHeaderCellDef>Run By</th>
                      <td mat-cell *matCellDef="let record">
                        @if (!record.isManualSync) {
<span class="badge badge-secondary" title="Triggered automatically by the background scheduler">Auto</span>
}
                        @if (record.isManualSync) {
<span class="badge badge-primary" title="Manually triggered">
                          Manual@if (record.triggeredBy) {
<span> ({{ record.triggeredBy }})</span>
}
                        </span>
}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let record">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-secondary no-arrow"
                          (click)="viewLogs(record.id)"
                          title="View per-app sync log details">
                          <mat-icon style="font-size:16px;height:16px;width:16px;vertical-align:middle;">list_alt</mat-icon>
                          Logs
                        </button>
                      </td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
}

                  <mat-paginator #historyPaginator
                    [length]="historyTotalCount"
                    [pageSize]="historyPageSize"
                    [pageIndex]="historyPage - 1"
                    [pageSizeOptions]="[10, 20, 50, 100]"
                    [showFirstLastButtons]="true"
                    (page)="onHistoryPageChange($event)">
                  </mat-paginator>
                </div>
              </div>
}

            </div>
          </mat-tab>

          <!-- Tab 2: Orion Update -->
          <mat-tab label="Orion Update">
            <div style="padding: 20px;">

              <!-- Bulk Orion Enrichment card -->
              <div class="card mb-20">
                <div class="card-body">
                  <h3>Orion Sync</h3>
                  <p class="muted">Re-fetch Orion manifests for <strong>all</strong> tracked apps in one go — without re-running the CMDB sync. The daily background sync automatically runs both CMDB and Orion together.</p>

                  <button
                    type="button"
                    class="btn btn-primary no-arrow"
                    (click)="runOrionEnrichment()"
                    [disabled]="orionEnrichRunning || status?.isSyncRunning">
                    @if (!orionEnrichRunning) {
<span>
                      <mat-icon style="font-size:16px;height:16px;width:16px;vertical-align:middle;">sync</mat-icon>
                      Run Orion Enrichment
                    </span>
}
                    @if (orionEnrichRunning) {
<span>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Enriching all apps...
                    </span>
}
                  </button>

                  <!-- Enrichment error -->
                  @if (orionEnrichError) {
<div class="alert alert-danger" style="margin-top: 16px;">
                    <mat-icon>error_outline</mat-icon>
                    {{ orionEnrichError }}
                  </div>
}

                  <!-- Enrichment started (runs in the background; progress shows in Sync History) -->
                  @if (orionEnrichStartedMessage) {
<div class="alert alert-info" style="margin-top: 16px;">
                    <mat-icon>info</mat-icon>
                    <span>{{ orionEnrichStartedMessage }}</span>
                  </div>
}

                </div>
              </div>

              <!-- Form card -->
              <div class="card mb-20">
                <div class="card-body">
                  <h3>Update Orion Manifest</h3>
                  <p class="muted">Enter an AppId (Service ID) to fetch the Orion manifest and save it to the tracked app record.</p>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="field-label">AppId / Service ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="orionAppId"
                          placeholder="e.g. 5055178"
                          (keyup.enter)="updateOrionManifest()" />
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-primary no-arrow"
                    (click)="updateOrionManifest()"
                    [disabled]="orionTesting || !orionAppId.trim()">
                    @if (!orionTesting) {
<span>Update Manifest</span>
}
                    @if (orionTesting) {
<span>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Fetching...
                    </span>
}
                  </button>
                </div>
              </div>

              <!-- HTTP error (unexpected) -->
              @if (orionError) {
<div class="alert alert-danger mb-20">
                <mat-icon>error_outline</mat-icon>
                {{ orionError }}
              </div>
}

              <!-- Result -->
              @if (orionResult) {


                <!-- Status banner -->
                <div [class]="orionResult.success ? 'alert alert-success mb-20' : 'alert alert-warning mb-20'">
                  <mat-icon>{{ orionResult.success ? 'check_circle' : 'warning' }}</mat-icon>
                  <span class="orion-result-text">{{ orionResult.message }}</span>
                  @if (orionResult.httpStatusCode) {
<span class="badge badge-info orion-http-code">HTTP {{ orionResult.httpStatusCode }}</span>
}
                </div>

                <!-- Failure diagnostics -->
                @if (!orionResult.success && orionResult.failureReason) {


                  <!-- OrionNotConfigured -->
                  @if (orionResult.failureReason === 'OrionNotConfigured') {
<div class="alert alert-warning mb-20">
                    <mat-icon>settings</mat-icon>
                    <div>
                      <strong>Orion API is not configured.</strong>
                      Set the following in app settings or Key Vault:
                      <ul class="orion-hint-list">
                        <li><code>OrionApi:BaseUrl</code> — e.g. <em>https://apim-stage-internal.chevron.com/.../orion-api/v1</em></li>
                        <li><code>OrionApi:SubscriptionKey</code> — APIM subscription key (or <code>kv:secret-name</code> for Key Vault)</li>
                        <li><code>OrionApi:Resource</code> — Azure AD OAuth app URI</li>
                      </ul>
                    </div>
                  </div>
}

                  <!-- NotFoundInOrion -->
                  @if (orionResult.failureReason === 'NotFoundInOrion') {
<div class="alert alert-info mb-20">
                    <mat-icon>search_off</mat-icon>
                    <div>
                      <strong>AppId not found in Orion (404).</strong>
                      Verify that <strong>{{ orionResult.appId }}</strong> is the correct numeric ServiceNow App ID.
                    </div>
                  </div>
}

                  <!-- AuthenticationFailed -->
                  @if (orionResult.failureReason === 'AuthenticationFailed') {
<div class="alert alert-danger mb-20">
                    <mat-icon>lock</mat-icon>
                    <div>
                      <strong>Authentication / authorization failed.</strong>
                      Check <code>OrionApi:SubscriptionKey</code>, <code>OrionApi:Resource</code>, and the managed identity permissions.
                    </div>
                  </div>
}

                  <!-- Timeout -->
                  @if (orionResult.failureReason === 'Timeout') {
<div class="alert alert-warning mb-20">
                    <mat-icon>timer_off</mat-icon>
                    <div>
                      <strong>Request timed out.</strong>
                      Check network connectivity to Orion or increase <code>OrionApi:TimeoutSeconds</code>.
                    </div>
                  </div>
}

                  <!-- Generic HttpError -->
                  @if (orionResult.failureReason === 'HttpError') {
<div class="alert alert-warning mb-20">
                    <mat-icon>http</mat-icon>
                    <div>
                      <strong>Unexpected HTTP error.</strong>
                      Verify <code>OrionApi:BaseUrl</code> is correct and the Orion API is reachable from this environment.
                    </div>
                  </div>
}

                
}

                <!-- JSON viewer (success) -->
                @if (orionResult.manifestJson) {
<div class="card">
                  <div class="card-body">
                    <div class="orion-json-header">
                      <h5>Manifest JSON</h5>
                      <span class="badge badge-info">{{ orionResult.manifestJson.length | number }} chars</span>
                    </div>
                    <pre class="orion-json-pre">{{ orionManifestFormatted }}</pre>
                  </div>
                </div>
}

              
}

            </div>
          </mat-tab>

          <!-- Tab 3: Settings -->
          <mat-tab label="Settings">
            <div style="padding: 20px;">

              @if (settingsLoading) {
<app-cmdb-sync-settings-skeleton></app-cmdb-sync-settings-skeleton>
}

              @if (!settingsLoading) {
<form [formGroup]="settingsForm" (ngSubmit)="saveSyncConfig()">
                <div class="card">
                  <div class="card-body">
                    <h3>Auto-Sync Configuration</h3>
                    <p class="muted">These settings control the background CMDB sync scheduler. Changes take effect on the next scheduling loop (within a few minutes).</p>

                    <!-- Boolean settings: checkboxes -->
                    <div class="form-group" style="margin-bottom: 24px; display: flex; flex-direction: column; gap: 16px;">

                      <!-- Auto Sync -->
                      <div>
                        <mat-checkbox formControlName="isAutoSyncEnabled" color="primary">
                          Enable Auto Sync
                        </mat-checkbox>
                        <div class="field-hint muted" style="margin-top: 4px; margin-left: 26px;">
                          When unchecked the background service will not run periodic syncs. Manual syncs from the Sync History tab still work.
                        </div>
                      </div>

                      <!-- Sync with Orion -->
                      <div>
                        <mat-checkbox formControlName="isSyncWithOrionEnabled" color="primary">
                          Sync with Orion
                        </mat-checkbox>
                        <div class="field-hint muted" style="margin-top: 4px; margin-left: 26px;">
                          When checked each sync run will also fetch Orion manifests for all tracked apps.
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <!-- Sync interval -->
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="field-label">Sync Interval (hours)</label>
                          <input
                            type="number"
                            class="form-control"
                            formControlName="syncIntervalHours"
                            min="1"
                            max="8760"
                            placeholder="e.g. 1" />
                          @if (settingsForm.get('syncIntervalHours')?.invalid && settingsForm.get('syncIntervalHours')?.touched) {
<div
                               class="text-danger" style="font-size: 0.85em; margin-top: 4px;">
                            Must be between 1 and 8760 hours.
                          </div>
}
                          <div class="field-hint muted" style="margin-top: 4px;">
                            Hours between automatic syncs (measured from completion of the last job).
                          </div>
                        </div>
                      </div>

                      <!-- Batch size -->
                      <div class="col-md-4">
                        <div class="form-group" style="display: none;">
                          <label class="field-label">Batch Size</label>
                          <input
                            type="number"
                            class="form-control"
                            formControlName="batchSize"
                            min="1"
                            max="1000"
                            placeholder="e.g. 100" />
                          @if (settingsForm.get('batchSize')?.invalid && settingsForm.get('batchSize')?.touched) {
<div
                               class="text-danger" style="font-size: 0.85em; margin-top: 4px;">
                            Must be between 1 and 1000.
                          </div>
}
                          <div class="field-hint muted" style="margin-top: 4px;">
                            Number of records fetched per batch from the CMDB API.
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Settings error -->
                    @if (settingsError) {
<div class="alert alert-danger" style="margin-top: 12px;">
                      <mat-icon>error_outline</mat-icon>
                      {{ settingsError }}
                    </div>
}

                    <!-- Saved confirmation -->
                    @if (settingsSaved) {
<div class="alert alert-success" style="margin-top: 12px;">
                      <mat-icon>check_circle</mat-icon>
                      Settings saved successfully.
                    </div>
}

                    <div style="margin-top: 20px;">
                      <button
                        type="submit"
                        class="btn btn-primary no-arrow"
                        [disabled]="settingsForm.invalid || settingsSaving">
                        @if (!settingsSaving) {
<span>Save Settings</span>
}
                        @if (settingsSaving) {
<span>
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Saving...
                        </span>
}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
}

            </div>
          </mat-tab>

        </mat-tab-group>
}
